module.exports = __webpack_public_path__ + "f1e40eb8b00ca2bfd453b2335f158d37.wav";